import { mountLegislature } from './utils/mount-legislature.js';
import { STATE_URL } from './constants.js';
import { called_house_races } from './close_races.js';
mountLegislature(
  'uncalled-california-us-house',
  STATE_URL,
  'H',
  called_house_races // Exclude Ids
).catch(console.error);
